module.exports = __webpack_public_path__ + "img/health-banner.987aae97.svg";